const esLang = {
  searchTitle1: 'Se encontraron',
  searchTitle2: 'resultados.',
  pagesResult: 'PÁGINAS',
  productsResult: 'PRODUCTOS',
  pagesLabel: 'Páginas',
  productsLabel: 'Productos',
  tagsLabel: 'Blog',
  tagsResult: 'BLOG',
  filtersLabel: 'Mostrar solo resultados de:',
  orderLabel: 'Ordenar por',
  amountLabel: 'Cantidad a mostrar',
  'libre-venta': 'Productos de libre acceso',
  'prescripcion': 'Medicamentos de prescripción',
  'salud-animal': 'Salud animal',
  'prncpioActv': 'Principio activo: ',
  'clasfccionTrptca': 'Clasificación terapéutica: ',
  'prsntcon': 'Presentación: ',
  'conteudo': 'Contenido',
  'cncntracion': 'Concentración',
  'nmCompanhia': 'Compañia: ',
  'nmUnidad': 'Unidad de negocio: ',
  'nmDivision': 'División',
  'classTrptca': 'Clase terapéutica',

  'nmDroga': 'Marca',
  'prncpioActvReg': 'Denominación genérica',
}
const enLang = {
  searchTitle1: '',
  searchTitle2: 'were found.',
  pagesResult: 'PAGES',
  productsResult: 'PRODUCTS',
  pagesLabel: 'Pages',
  productsLabel: 'Products',
  tagsLabel: 'Blog',
  tagsResult: 'BLOG',
  filtersLabel: 'Show only results from',
  orderLabel: 'Order by',
  amountLabel: 'Amount to display',
  'libre-venta': 'Over-the-counter medications',
  'prescripcion': 'Prescription drugs',
  'salud-animal': 'Animal health',
  'prncpioActv': 'Active principle:',
  'clasfccionTrptca': 'Therapeutic classification:',
  'prsntcon': 'Presentation:',
  'conteudo': 'Content',
  'cncntracion': 'Concentration',
  'nmCompanhia': 'Company:',
  'nmUnit': 'Business unit:',
  'nmDivision': 'Division',
  'classTrptca': 'Therapeutic class',

  'nmDroga': 'Marca',
  'prncpioActvReg': 'Denominación genérica',
}

export const langTexts = {
  es: esLang,
  en: enLang
}